import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { OKTA_AUTH } from '@okta/okta-angular'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oktaAuth = inject(OKTA_AUTH)
  const token = oktaAuth.getAccessToken()
  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    })
  }
  return next(req)
}
